import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export type Locale = "en" | "ar";

export function applyLocaleToDocument(locale: Locale) {
  if (typeof document === "undefined") return;
  document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = locale === "ar" ? "ar" : "en";
}

interface LocaleState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

const localeStore = (set: (fn: (state: LocaleState) => Partial<LocaleState>) => void): LocaleState => ({
  locale: "en",
  setLocale: (locale: Locale) => {
    applyLocaleToDocument(locale);
    set(() => ({ locale }));
  },
});

const useLocaleStore = create<LocaleState>()(
  devtools(
    persist(localeStore, {
      name: "whitelabel_locale",
      partialize: (state) => ({ locale: state.locale }),
      onRehydrateStorage: () => (state) => {
        if (state?.locale) {
          applyLocaleToDocument(state.locale);
        }
      },
    })
  )
);

export default useLocaleStore;
